import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../services/api";
import { FaEye } from "react-icons/fa";
import { IoRefresh } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Loading from "../../components/Loader/Loading";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MarkdownIt from "markdown-it";
import Modal from "../../components/common/Modal";
import { convertMarkdownTablesToHtml } from "../../utils/common";
const GenerateContentPage = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingTitles, setIsLoadingTitles] = useState(false);
  const [isLoadingBlog, setIsLoadingBlog] = useState(false);
  const [isLoadingPublish, setIsLoadingPublish] = useState(false);
  const [keywords, setKeywords] = useState(null);
  const [content, setContent] = useState(null);
  const [currentKeyword, setCurrentKeyword] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isTitleSidebar, setIsTitleSidebar] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [titles, setTitles] = useState(null);
  const [activeContentTab, setActiveContentTab] = useState("slogan_1");

  const { domain } = location.state || {};
  const parseKeywords = (raw) => {
    try {
      if (typeof raw !== "string") return [];

      return raw
        .split(/\r?\n/)
        .map((line) =>
          line
            .replace(/^\s*\d+\.\s*/, "") // remove numbering like "1. "
            .replace(/^"|"$/g, "") // remove surrounding quotes
            .trim()
        )
        .filter((line) => line.length > 0)
        .map((keyword) => ({
          keyword,
        }));
    } catch (e) {
      console.error("Failed to parse keywords payload:", e);
      return [];
    }
  };

  const parseMarkdownToServiceFormat = (markdownContent) => {
    if (!markdownContent || typeof markdownContent !== "string") {
      return {};
    }

    // Split content by headings (##)
    const sections = markdownContent.split(/\n## /);

    if (sections.length < 2) {
      return {};
    }

    const mainTitle = sections[0].trim();
    const headingSections = sections.slice(1);

    const result = {
      slogan_1: mainTitle,
    };

    // Process up to 4 heading sections
    headingSections.slice(0, 4).forEach((section, index) => {
      const lines = section.split("\n");

      const title = `# ${lines[0].trim()}`;
      const content = `${lines.slice(1).join("\n")}`.trim();

      const serviceNumber = index + 1;
      result[`title_${serviceNumber}`] = title;
      result[`text_${serviceNumber}`] = content;
    });

    return result;
  };

  const convertStructuredContentToArray = (structuredContent) => {
    const contentArray = [];
    if (structuredContent.slogan_1) {
      // contentArray.push({ type: "h1", text: structuredContent.slogan_1 });
      contentArray.push({ type: "p", text: structuredContent.slogan_1 });
    }

    for (let i = 1; i <= 4; i++) {
      const title = structuredContent[`title_${i}`];
      const text = structuredContent[`text_${i}`];

      if (title) {
        // contentArray.push({ type: "h3", text: title });
        contentArray.push({ type: "p", text: title });
      }

      if (text) {
        const paragraphs = text.split("\n\n").filter((p) => p.trim());
        paragraphs.forEach((paragraph) => {
          contentArray.push({ type: "p", text: paragraph.trim() });
        });
      }
    }

    return contentArray;
  };

  // Function to parse content array format to service format
  // const parseContentArrayToServiceFormat = (contentArray) => {
  //   if (!Array.isArray(contentArray) || contentArray.length === 0) {
  //     return {};
  //   }

  //   const result = {};
  //   let currentSection = null;
  //   let currentContent = [];
  //   let sectionCount = 0;

  //   contentArray.forEach((item) => {
  //     if (item.type === "p" && item.text) {
  //       const text = item.text.trim();

  //       // Check if it's a main title (starts with #)
  //       if (text.startsWith("# ")) {
  //         result.slogan_1 = text.replace("# ", "").trim();
  //       }
  //       // Check if it's a section heading (starts with ##)
  //       else if (text.startsWith("## ")) {
  //         // If we have a previous section, save it
  //         if (currentSection && currentContent.length > 0 && sectionCount < 4) {
  //           sectionCount++;
  //           result[`title_${sectionCount}`] = currentSection;
  //           result[`text_${sectionCount}`] = currentContent.join("\n\n").trim();
  //         }

  //         // Start new section
  //         currentSection = text.replace("## ", "").trim();
  //         currentContent = [];
  //       }
  //       // Regular paragraph content
  //       else if (text && currentSection) {
  //         currentContent.push(text);
  //       }
  //     }
  //   });

  //   // Don't forget to save the last section
  //   if (currentSection && currentContent.length > 0 && sectionCount < 4) {
  //     sectionCount++;
  //     result[`title_${sectionCount}`] = currentSection;
  //     result[`text_${sectionCount}`] = currentContent.join("\n\n").trim();
  //   }

  //   return result;
  // };
  const parseContent = (raw) => {
    const lines = raw?.content?.split(/\r?\n/);
    const content = [];

    lines.forEach((line) => {
      if (line.startsWith("H1: ")) {
        content.push({ type: "h1", text: line.slice(4).trim() });
      } else if (line.startsWith("H3: ")) {
        content.push({ type: "h3", text: line.slice(4).trim() });
      } else if (line.trim()) {
        content.push({ type: "p", text: line.trim() });
      }
    });
    const { content: rawContent, ...rest } = raw;
    return {
      ...raw,
      content,
      markdown: {
        ...rest,
        ...parseMarkdownToServiceFormat(raw?.content || ""),
      },
    };
  };

  const getKeywords = async (keyword) => {
    setIsLoading(true);
    setIsTitleSidebar(false);
    setTitles(null);
    try {
      const res = await api.post(`/api/domains/seo/generate_keywords`, {
        domain: domain,
        domain_keyword: keyword,
      });
      if (res.status === 200) {
        setKeywords(res.data?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getDetails = async (keyword) => {
    setIsLoadingTitles(true);
    setIsTitleSidebar(true);
    setIsSidebarCollapsed(true);

    try {
      const res = await api.post(`/api/domains/seo/generate_titles`, {
        keyword: keyword.keyword,
      });
      if (res.status === 200) {
        const parsed = parseKeywords(res.data?.data);
        setTitles(parsed);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingTitles(false);
    }
  };

  const handleView = async (item) => {
    setCurrentKeyword(item);
    setIsLoadingBlog(true);
    try {
      const res = await api.post(`/api/domains/seo/generate_content`, {
        title: item.keyword,
      });
      if (res.status === 200) {
        let contentData = res.data?.data;
        if (typeof contentData === "string") {
          try {
            contentData = JSON.parse(contentData);
          } catch (e) {
            console.error("Failed to parse content data:", e);
          }
        }
        const parsed = parseContent(contentData);
        setContent(parsed);
      }
      // setBlog(blogData);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message || "Failed to publish content");
    } finally {
      setIsLoadingBlog(false);
    }
  };

  const handlePublish = async () => {
    setIsLoadingPublish(true);
    try {
      const res = await api.post(`/api/domains/seo/publish_content`, {
        content: JSON.stringify(content?.markdown),
        domain,
      });
      if (res.status === 200) {
        toast.success("Content published successfully");
      } else {
        toast.error(res.data.message || "Failed to publish content");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingPublish(false);
    }
  };

  const handleRefresh = () => {
    if (currentKeyword) {
      handleView(currentKeyword);
    }
  };

  const handleSearch = (keyword) => {
    if (keyword) {
      getKeywords(keyword);
      setContent(null);
    }
  };

  const renderCards = () => {
    return keywords?.map((item, idx) => (
      <div className="flex gap-2" key={idx}>
        <div className="border border-gray-200 rounded-lg p-4 mb-3 bg-gray-50 shadow-sm w-[90%]">
          <div>
            <span className="font-semibold">Title:</span> {item.keyword}
          </div>
          <div>
            <span className="font-semibold">Volume:</span> {item.volume}
          </div>
          <div>
            <span className="font-semibold">Difficulty:</span>{" "}
            {item.difficulty !== null ? item.difficulty : "N/A"}
          </div>
        </div>
        <div className="cursor-pointer flex items-center justify-center w-[10%]">
          <FaEye
            className="text-lg text-gray-500"
            onClick={() => getDetails(item)}
          />
        </div>
      </div>
    ));
  };

  const formatMarkdown = (content) => {
    if (!content) return "";
    if (Array.isArray(content)) {
      return content
        .map((item) => {
          switch (item.type) {
            case "h1":
              return `# ${item.text}\n\n`;
            case "h3":
              return `## ${item.text}\n\n`;
            case "p":
              return `${item.text}\n\n`;
            default:
              return item.text;
          }
        })
        .join("");
    }
    if (typeof content === "string") {
      let textWithLineBreaks = content.replace(
        /\r\r\r\n\s*\r\r\r\n/g,
        "<br><br>\n\n"
      );
      textWithLineBreaks = textWithLineBreaks.replace(
        /\r\n\s*\r\n/g,
        "<br><br>\n\n"
      );
      return textWithLineBreaks;
    }

    return "";
  };

  const markdownIt = new MarkdownIt();
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <>
      {isLoading && <Loading />}
      <div className="flex h-[calc(100vh-50px)] gap-1">
        <div
          className={`${
            isSidebarCollapsed ? "w-16" : "w-[25%] max-w-[25%]"
          } border border-gray-300 p-4 bg-white h-full overflow-y-auto relative transition-all duration-300 ease-in-out`}
        >
          <div className="flex justify-between items-center mb-4">
            {!isSidebarCollapsed && (
              <div className="text-sm font-bold mb-4 flex items-center justify-center flex-col">
                <h3 className="text-lg font-bold mb-1">
                  Keywords to generate Content
                </h3>
                <div className="text-sm text-gray-500">{`(${domain})`}</div>
              </div>
            )}
            <button
              onClick={toggleSidebar}
              className={`${
                isSidebarCollapsed ? "mx-auto" : "ml-auto"
              } p-2 rounded-md hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50`}
              title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              {isSidebarCollapsed ? (
                <FaChevronRight className="h-4 w-4 text-gray-600" />
              ) : (
                <FaChevronLeft className="h-4 w-4 text-gray-600" />
              )}
            </button>
          </div>

          {!isSidebarCollapsed && (
            <>
              <div className="relative mb-4">
                <input
                  type="text"
                  placeholder="Search keywords..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="block w-full pr-12 pl-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
                <div className="absolute inset-y-0 right-0 pr-1 flex items-center">
                  <button
                    onClick={() => handleSearch(searchTerm)}
                    className="!bg-[#042A42] text-white p-2 rounded-md hover:!bg-[#031a2e] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#042A42] focus:ring-opacity-50 shadow-sm hover:shadow-md transform hover:scale-105"
                    type="button"
                  >
                    <FaSearch className="h-4 w-4" />
                  </button>
                </div>
              </div>

              {isLoading ? null : keywords && keywords.length > 0 ? (
                renderCards()
              ) : (
                <div className="flex flex-col items-center justify-center h-full text-center text-gray-400">
                  <span className="text-5xl mb-2">🔍</span>
                  <div className="text-lg font-semibold mb-1">
                    Search for a keyword
                  </div>
                  <div className="text-sm">
                    {keywords
                      ? "No keywords match your search criteria."
                      : "Try selecting a different domain or check back later."}
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {isTitleSidebar && (
          <div className="w-[25%] max-w-[20%]  border border-gray-300 p-4 bg-white h-full overflow-y-auto transition-all duration-300 ease-in-out">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold">Generated Titles</h2>
            </div>

            {isLoadingTitles ? (
              <div className="flex items-center justify-center h-[70vh]">
                <img src="/img/loading.gif" className="w-16" alt="Loading..." />
              </div>
            ) : titles && titles.length > 0 ? (
              <div className="space-y-3">
                {titles.map((item) => {
                  return (
                    <div
                      key={item.keyword}
                      className={`border border-gray-200 rounded-lg p-3 transition-colors duration-200 cursor-pointer 
                          ${
                            currentKeyword?.keyword === item.keyword
                              ? "bg-blue-200 text-black hover:bg-blue-300"
                              : "bg-gray-100 text-gray-800 hover:bg-blue-900 hover:text-gray-800"
                          }`}
                      onClick={() => handleView(item)}
                    >
                      <div className="font-medium text-sm mb-1">
                        {item.keyword}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-center text-gray-400">
                <div className="text-sm">No titles generated yet</div>
              </div>
            )}
          </div>
        )}

        <div
          className={`${
            isSidebarCollapsed
              ? "w-[calc(100%-4rem)]"
              : isTitleSidebar
              ? "w-[55%]"
              : "w-[75%]"
          } border border-gray-300  bg-white h-full overflow-y-auto transition-all duration-300 ease-in-out`}
        >
          {isLoadingBlog ? (
            <div className="flex items-center justify-center h-full">
              <img src="/img/loading.gif" className="w-16" alt="Loading..." />
            </div>
          ) : content ? (
            <div className=" p-4 border border-blue-200 rounded-lg bg-blue-50">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-semibold mb-2">Content Preview</h3>
                <div className="flex items-center gap-2">
                  <button
                    className="btnPrimary !bg-[#042A42] text-white font-bold py-2 px-5 rounded-lg shadow transition-colors duration-200 cursor-pointer"
                    onClick={handleRefresh}
                    disabled={isLoadingPublish}
                  >
                    {isLoadingPublish ? (
                      <img
                        src="/img/loading.gif"
                        className="w-5 h-5 mr-2"
                        alt="Publishing..."
                      />
                    ) : null}
                    <IoRefresh className=" w-5 h-5 " />
                  </button>
                  <button
                    className="btnPrimary !bg-[#042A42] text-white font-bold py-2 px-5 rounded-lg shadow transition-colors duration-200 cursor-pointer"
                    onClick={() => {
                      // Set the active tab to the first key in content.markdown
                      if (
                        content?.markdown &&
                        Object.keys(content.markdown).length > 0
                      ) {
                        const firstKey = Object.keys(content.markdown)[0];
                        setActiveContentTab(firstKey);
                      }
                      setIsOpen(true);
                    }}
                  >
                    {/* <MdOutlineEdit className=" w-5 h-5 " /> */}
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              {content && (
                <div className="mb-2">
                  <span className="font-bold">Meta Title: </span>
                  <span className="tracking-wide">{content.meta_title}</span>
                </div>
              )}
              {content && (
                <div className="mb-2">
                  <span className="font-bold">Meta Heading: </span>
                  <span className="tracking-wide">{content.meta_heading}</span>
                </div>
              )}
              {content && (
                <div className="mb-2">
                  <span className="font-bold">Meta Description: </span>
                  <span className="tracking-wide">
                    {content.meta_description}
                  </span>
                </div>
              )}
              {content?.content && (
                <div className="mb-2">
                  <div className="tracking-wide prose max-w-none prose-h1:text-lg prose-h3:text-lg prose-p:text-base">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: markdownIt.render(
                          convertMarkdownTablesToHtml(
                            `${formatMarkdown(content?.content)}`
                          )
                        ),
                      }}
                    />
                  </div>
                </div>
              )}
              <div className="flex justify-end mt-4">
                <button
                  className="btnPrimary !bg-[#042A42] text-white font-bold py-2 px-5 rounded-lg shadow transition-colors duration-200"
                  onClick={handlePublish}
                  disabled={isLoadingPublish}
                >
                  {isLoadingPublish ? (
                    <img
                      src="/img/loading.gif"
                      className="w-5 h-5 mr-2"
                      alt="Publishing..."
                    />
                  ) : null}
                  Publish Content
                </button>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-center   p-10 border-2 border-blue-200 shadow-md">
              <div className="text-3xl  mb-3 text-gray-500">
                No Content Selected
              </div>
              <div className="text-lg text-gray-500">
                Select a keyword from the left to generate and preview a content
                post here. The content details will appear in this section once
                you select a keyword.
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
      <Modal
        open={!isOpen}
        handleModal={() => setIsOpen(false)}
        className="max-w-[80%]"
        title="Generate Content"
        modalType="edit"
        handleModalSubmit={(e) => {
          e.preventDefault();
          setContent((prev) => ({
            ...prev,
            // content: prev.markdown,
            content: convertStructuredContentToArray(prev.markdown),
          }));

          setIsOpen(false);
        }}
      >
        <div>
          {content?.markdown &&
            Object.keys(content.markdown)?.map((key, idx) => (
              <button
                key={idx}
                type="button"
                className={`px-3 py-2 text-sm border-b-2 -mb-px ${
                  activeContentTab === key
                    ? "border-[#0000FF] !text-blue-700 font-semibold"
                    : "border-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveContentTab(key)}
              >
                {key
                  ?.replace(/_/g, " ")
                  ?.replace(/\b\w/g, (l) => l.toUpperCase())}
              </button>
            ))}

          <textarea
            value={content?.markdown?.[activeContentTab] || ""}
            onChange={(e) => {
              const value = e.target.value;
              setContent((prev) => ({
                ...prev,
                markdown: {
                  ...prev.markdown,
                  [activeContentTab]: value,
                },
              }));
            }}
            className="w-full h-96 border border-blue-300 rounded-md p-3 font-mono text-sm resize-none"
            placeholder={`Enter ${
              activeContentTab === "slogan_1"
                ? "main title"
                : activeContentTab.replace(/_/g, " ")
            } here...`}
          />
        </div>
      </Modal>
    </>
  );
};

export default GenerateContentPage;
